/**
 * @flow
 */

export const TITLE_OPTIONS = [
  { value: "MR", label: "Mr" },
  { value: "MRS", label: "Mrs" },
  { value: "MISS", label: "Miss" },
  { value: "DR", label: "Dr" },
  { value: "PROF", label: "Prof" },
  { value: "MS", label: "Ms" },
]

export const titleLabel = (value: ?string): string => {
  const option = TITLE_OPTIONS.find(o => o.value === value)
  return option ? option.label : ""
}
